export class SetUserEditId {
  static readonly type = '[SHARED-EDIT] Set user id to edit';
  constructor(public userEditId: number) {}
}

export class SetUserEditIsEditing {
  static readonly type = '[SHARED-EDIT] Set user is editing';
  constructor(public userEditIsEditing: boolean) {}
}
